import { render, staticRenderFns } from "./MasterPengurus.vue?vue&type=template&id=13fb571b&"
import script from "./MasterPengurus.vue?vue&type=script&lang=js&"
export * from "./MasterPengurus.vue?vue&type=script&lang=js&"
import style0 from "./MasterPengurus.vue?vue&type=style&index=0&id=13fb571b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports